import React from "react";
import { ReactLenis } from "lenis/react";
import Navbar from "../../components/Navbar/Navbar";
import Home from "../../components/Home/Home";
import About from "../../components/About/About";
import Education from "../../components/Education/Education";
import Projects from "../../components/Projects/Projects";
import Experience from "../../components/Experiences/Experience";
import { ContactUs } from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";
import "../Landing/Landing.css";

function Landing() {
  return (
    <ReactLenis root>
      <div className='min-h-screen w-full overflow-x-clip bg-background font-body text-text'>
        <Navbar />
        <main>
          <Home />
          <About />
          <Education />
          <Projects />
          <Experience />
          <ContactUs />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default Landing;
